import React, { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routes";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./themes/theme";

function App() {
  return (
    <Suspense fallback="loading">
      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider>
    </Suspense>
  );
}

export default App;
